import { Select } from 'antd';
import { useUnit } from 'effector-react';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  $activeCity,
  $cities,
  $language,
  changeActiveCityEv,
  getCitiesEv,
} from '../../models/logicModel/index.js';
import { $userInfo } from '../../models/authModel/index.js';

function CitySelector() {
  const cities = useUnit($cities);
  const getCities = useUnit(getCitiesEv);
  const activeCity = useUnit($activeCity);
  const changeActiveCity = useUnit(changeActiveCityEv);
  const userInfo = useUnit($userInfo);
  const [searchParams, setSearchParams] = useSearchParams();
  const language = useUnit($language);

  useEffect(() => {
    getCities();
  }, []);

  const onChange = (value) => {
    if (userInfo.perms.length === 0) {
      setSearchParams({ city_id: value });
    }
    changeActiveCity(value);
  };

  const formOptions = () => {
    if (cities.length === 0) return [];
    return cities.map((city) => {
      return {
        label: city[language === 'ru' ? 'name' : 'transcript'],
        value: city.city_id,
      };
    });
  };

  return (
    <Select
      disabled={userInfo?.perms.length !== 0}
      options={formOptions()}
      style={{ width: 150 }}
      value={activeCity}
      onChange={onChange}
    />
  );
}

export default CitySelector;
